import { Flex, Select, SelectProps, Spin } from 'antd';
import './style.scss';

const SelectComponent = ({
  label,
  loading,
  hint,
  ...props
}: SelectProps & { label?: string; hint?: React.ReactNode }) => {
  const select = (
    <>
      <Select
        className="custom-select"
        showSearch={true}
        optionFilterProp="label"
        loading={loading}
        notFoundContent={
          loading ? (
            <Flex justify="center" align="center">
              <Spin />
            </Flex>
          ) : undefined
        }
        {...props}
      />
      {hint ? (
        <p className="custom-select__hint" style={{ marginTop: '4px' }}>
          {hint}
        </p>
      ) : null}
    </>
  );
  return label ? (
    <div className="custom-select-container">
      <div className="custom-select-container__label">{label}</div>
      {select}
    </div>
  ) : (
    <>{select}</>
  );
};

export default SelectComponent;
